import type { AiToolFieldMaskExpansionConfig } from '@erikdakoda/ai-tool/findManyAiToolInput';
import { AiModelForAiToolsSearchSelect, AiModelForEditSelect } from '../types';

/** Scalar AI model fields for read/edit flat select masks. */
export const AI_MODEL_AI_TOOL_SCALAR_FIELDS = [
  'id',
  'integration',
  'modelName',
  'label',
  'description',
  'inContext',
  'outContext',
  'dimensions',
  'inMegaTokCost',
  'outMegaTokCost',
  'cachedMegaTokCost',
  'audioInMegaTokCost',
  'audioInMinuteCost',
  'cacheWriteMegaTokCost',
  'modalities',
  'features',
  'endpoints',
  'benchmarkSlug',
  'reasoning',
  'speed',
  'intelligenceIndex',
  'tokensPerSec',
  'disabled',
  'releasedAt',
  'knowledgeAt',
  'createdAt',
  'updatedAt',
] as const;

/** Minimal listing mask fields for AI model search/find tools. */
export const AI_MODEL_AI_TOOL_SEARCH_SCALAR_FIELDS = [
  'id',
  'modelName',
  'integration',
  'label',
  'description',
] as const;

/** AI model fields available in find/filter DSL. */
export const AI_MODEL_AI_TOOL_FILTER_FIELDS = [
  'id',
  'modelName',
  'integration',
  'label',
  'description',
  'disabled',
  'releasedAt',
  'knowledgeAt',
] as const;

/** AI model fields agents may sort by in find tools. */
export const AI_MODEL_AI_TOOL_SORTABLE_FIELDS = [
  'modelName',
  'integration',
  'label',
  'createdAt',
  'updatedAt',
  'releasedAt',
  'knowledgeAt',
  'inMegaTokCost',
  'outMegaTokCost',
  'reasoning',
  'speed',
  'disabled',
] as const;

/** Expands AI model flat select masks for read/edit tools. */
export const aiModelForEditFieldMaskConfig: AiToolFieldMaskExpansionConfig = {
  defaultSelect: AiModelForEditSelect,
  scalarFields: AI_MODEL_AI_TOOL_SCALAR_FIELDS,
};

/** Expands AI model flat select masks for search/find listing tools. */
export const aiModelForSearchFieldMaskConfig: AiToolFieldMaskExpansionConfig = {
  defaultSelect: AiModelForAiToolsSearchSelect,
  scalarFields: AI_MODEL_AI_TOOL_SEARCH_SCALAR_FIELDS,
};

export const aiModelFilterFieldMappings = {
  id: { path: ['id'], valueType: 'string' },
  modelName: { path: ['modelName'], valueType: 'string' },
  integration: { path: ['integration'], valueType: 'string' },
  label: { path: ['label'], valueType: 'string' },
  description: { path: ['description'], valueType: 'string' },
  disabled: { path: ['disabled'], valueType: 'boolean' },
  releasedAt: { path: ['releasedAt'], valueType: 'date' },
  knowledgeAt: { path: ['knowledgeAt'], valueType: 'date' },
} as const;

export const aiModelOrderByFieldPaths = {
  modelName: ['modelName'],
  integration: ['integration'],
  label: ['label'],
  createdAt: ['createdAt'],
  updatedAt: ['updatedAt'],
  releasedAt: ['releasedAt'],
  knowledgeAt: ['knowledgeAt'],
  inMegaTokCost: ['inMegaTokCost'],
  outMegaTokCost: ['outMegaTokCost'],
  reasoning: ['reasoning'],
  speed: ['speed'],
  disabled: ['disabled'],
} as const;
